module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "display-image1",
    staticStyle: {
      "margin-top": "10%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevi"
    }
  }), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fm-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "display-image2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/sequer.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#toc1a",
      "id": "toc1"
    }
  }, [_vm._v("1. Blood Sacrifice in Texas")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#toc2a",
      "id": "toc2"
    }
  }, [_vm._v("2. Planting Seeds")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#toc3a",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Growing Season")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#toc4a",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. First Harvest: Portrait of a Budding Magnate")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#toc5a",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Recruiting New Hands for the Second Crop: The Band Begins to Gather")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#toc6a",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The $60,000 Incubator")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#toc7a",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Salad Days")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#toc8a",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Worm in the Apple")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#toc9a",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Cutting the Jell-O")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#toc10a",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Haddock Almondine and Chicken-Fried Steak")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#toc11a",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Worm Gnaws Deeper")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#toc12a",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Scalloped Squash and Spinach Pudding")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#toc13a",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Yeast Rolls, Biscuits, and Two Kinds of Cornbread")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#toc14a",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Cherry Cobbler and Coconut Cream Pie")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#toc15a",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Deviled Eggs and Stuffed Jalapeños")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#toc16a",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Hot Coffee, Iced Tea, Pink Lemonade, or Just Plain Water")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#toc17a",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Condiments on the Side")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#toc18a",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Dirty Dishes")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#toc19a",
      "id": "toc19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Over, Fork Over")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#toc20a",
      "id": "toc20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Leftovers")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "1.8em",
      "margin-bottom": "1.8em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/epilogue#toc21a",
      "id": "toc21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/afterword#toc22a",
      "id": "toc22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword by Carol Johnston")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/tree#toc23a",
      "id": "toc23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luby Family Tree ("), _c('i', [_vm._v("partial")]), _vm._v(")")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/ack#toc24a",
      "id": "toc24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/selectref#toc25a",
      "id": "toc25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/index#toc26a",
      "id": "toc26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0